import { render } from "./FixedRateIcon.vue?vue&type=template&id=3f6ff16b"
import script from "./FixedRateIcon.vue?vue&type=script&lang=js"
export * from "./FixedRateIcon.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__